import {Component, Input, OnInit} from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'app-primeiro-texto',
  templateUrl: './primeiro-texto.component.html',
  styleUrls: ['./primeiro-texto.component.scss']
})
export class PrimeiroTextoComponent implements OnInit {

  @Input() title = '';
  @Input() date = '';
  @Input() content = '';
  @Input() slogan = null;
  @Input() next = null;


  constructor(private router: Router) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    };
  }

  ngOnInit(): void {
  }

  redirect(rota){
    console.log(rota);
    this.router.navigateByUrl(rota);
  }

}
